import { SignUpAllowed } from '@/types';
import client from './client';

async function get() {
  const { data } = await client.get<SignUpAllowed>(`/signUpAllowed`);
  return data;
}

async function add({ type, allowed }: { type: 'domains' | 'emails'; allowed: string }) {
  const { data } = await client.patch<SignUpAllowed>(`/signUpAllowed`, {
    type,
    allowed,
  });
  return data;
}

async function remove({ type, allowed }: { type: 'domains' | 'emails'; allowed: string }) {
  const { data } = await client.delete<SignUpAllowed>(`/signUpAllowed`, {
    params: { type, allowed },
  });
  return data;
}

export const signUpAllowed = {
  get,
  add,
  remove,
};
